import { apiSlice } from "app/api/apiSlice"


export const mainSettingsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['mainSettings'],
    endpoints: builder => ({
        getMainSettings: builder.query({
            query: () => 'utility/settings',
            keepUnusedDataFor: 5,
            providesTags: ['mainSettings']
        }),
        setMainSettings: builder.mutation({
            query: data => ({
                url: 'utility/settings',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['mainSettings']
        })
    })
})

export const {
    useGetMainSettingsQuery,
    useLazyGetMainSettingsQuery,
    useSetMainSettingsMutation
} = mainSettingsApiSlice